/**
 * Ключ перевода по значению enum с защитой от роста enum на бэкенде: пока
 * кабинет не обновил карту (`Record<Enum, string>` покрывает только
 * известные сегодня значения TypeScript), значение вне неё на рантайме
 * даёт `undefined`, а не пустой чип/`t(undefined)`. Общий помощник фичи:
 * `entities/marketing` такого не экспортирует (проверено на Task 17/18),
 * а заводить свой `?? FALLBACK` на каждой карте (статус, триггер, а
 * дальше, тип узла графа, причина ошибки графа) значит повторяться.
 * Отдельный модуль без зависимостей: его импортируют и automationLabels,
 * и journeyLabels, так между ними нет цикла импорта на рантайме.
 */
export function labelKeyFor<T extends string>(
  map: Record<T, string>,
  value: T | null | undefined,
  fallbackKey: string
): string {
  if (value == null) return fallbackKey;
  // Только свои ключи карты: значение вроде "constructor" не должно найти
  // функцию прототипа вместо текста.
  return Object.prototype.hasOwnProperty.call(map, value)
    ? map[value]
    : fallbackKey;
}
